import Vue from 'vue';

/* eslint-disable */
const meta = require('./../../oneweb.js');
const NAME = `${meta.aemComponentConfig.productPrefix}-${meta.aemComponentConfig.tagNameWithoutPrefix}`;

/**
 * vue needs to know the asset uri url to download the chunks
 */
export const initAssetServer = () => {
  console.log("Version: " + NAME + "-" + meta.version)
  Vue.prototype.$publicPath = ""
  if (window.aemNamespace) {
    // AEM MOCK SERVER
    if (window.aemNamespace.environmentVariables[NAME]) {
      // eslint-disable-next-line no-undef
      Vue.prototype.$publicPath = `${window.aemNamespace.environmentVariables[NAME].__webpack_public_path__}`;
      // __webpack_public_path__ = `${window.aemNamespace.environmentVariables[NAME].__webpack_public_path__}`;
    }
    // AEM servers
    if (window.aemNamespace.environmentVariables.assetUri && !window.aemNamespace.environmentVariables[NAME]) {
      // eslint-disable-next-line no-undef
      Vue.prototype.$publicPath = `${window.aemNamespace.environmentVariables.assetUri}/${NAME}/latest/`;
      // __webpack_public_path__ = `${window.aemNamespace.environmentVariables.assetUri}/${NAME}/latest/`;
    }
    if (window.aemNamespace.environmentVariables.stage !== 'prod') {
      // eslint-disable-next-line no-undef
    }
  }
};
